import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74078cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "field structure" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Nome", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "list-options" }
const _hoisted_8 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    isActive: _ctx.show,
    title: "Atribuição de Gateways",
    onCloseModalClick: _ctx.close
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-network-wired" })
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode("Dados da Estrutura "),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("input", {
              class: "input",
              type: "text",
              value: _ctx.selectedStructure.name,
              readonly: ""
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode("Definir Gateways "),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gateways, (gateway) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "checkbox",
                key: gateway.id
              }, [
                _createVNode(_component_CheckBox, {
                  checked: _ctx.selectedGateways.includes(gateway.id),
                  onClick: ($event: any) => (_ctx.selectGateway(gateway.id))
                }, null, 8, ["checked", "onClick"]),
                _createElementVNode("span", null, _toDisplayString(gateway.mac), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "button delete-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "Cancelar"),
        _createElementVNode("button", {
          class: "button save-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save(_ctx.selectedStructure.id, _ctx.selectedGateways)))
        }, "Salvar")
      ])
    ]),
    _: 1
  }, 8, ["isActive", "onCloseModalClick"]))
}